import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { color } from '@/colors';
import { I18N_KEYS } from '@/language/keys';
import { FlexCenVer, FlexCol } from '@/UI/styles';
import { Input } from '@/UI/Input/Input';
import { AppCheckbox } from '@/UI/AppCheckbox/AppCheckbox';
import { FieldLabelRow } from './PublishToCommunityModalDescription';

interface PublishToCommunityModalDetailsProps {
  supportEmail: string;
  onSupportEmailChange: (v: string) => void;
  agreedToTerms: boolean;
  onAgreedToTermsChange: (v: boolean) => void;
  termsError: string | null;
  onTermsClick: () => void;
}

const PublishToCommunityModalDetails = ({
  supportEmail,
  onSupportEmailChange,
  agreedToTerms,
  onAgreedToTermsChange,
  termsError,
  onTermsClick,
}: PublishToCommunityModalDetailsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <FlexCol>
        <FieldLabelRow
          label={t(I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.EMAIL_LABEL)}
        />
        <Input value={supportEmail} onChange={(e) => onSupportEmailChange(e.target.value)} size="large" fullWidth />
      </FlexCol>

      <FlexCol>
        <FieldLabelRow
          label={t(I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.PROFILE_LABEL)}
        />
        {/* TODO: replace placeholder block with the real publishing-identity selector once the backend defines it. */}
        <FlexCol
          sx={{
            height: 80,
            background: color.White04_T,
            border: `1px dashed ${color.White16_T}`,
            borderRadius: 1,
          }}
        />
      </FlexCol>

      <FlexCol sx={{ gap: 1 }}>
        <Typography variant="body-sm-rg" color={color.White64_T}>
          {t(I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.TERMS_LABEL)}
        </Typography>
        <FlexCenVer sx={{ gap: 1 }}>
          <AppCheckbox size="small" checked={agreedToTerms} onChange={(_, checked) => onAgreedToTermsChange(checked)} />
          <Typography variant="body-sm-rg" color={color.White64_T}>
            {t(I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.TERMS_AGREE_PREFIX)}{' '}
            <span
              role="button"
              tabIndex={0}
              onClick={onTermsClick}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onTermsClick();
                }
              }}
              style={{ color: color.Yellow100, cursor: 'pointer' }}
            >
              {t(I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.TERMS_LINK)}
            </span>
          </Typography>
        </FlexCenVer>
        {termsError && (
          <Typography variant="body-sm-rg" color={color.Weavy_Error}>
            {termsError}
          </Typography>
        )}
      </FlexCol>
    </>
  );
};

export default PublishToCommunityModalDetails;
